<script>
  import Photos from '@app-components/rec_object/parts/Photos.svelte';

  export let mobile = false;
  export let hovered = false;
  export let items;
  export let user;

  let mediaMap = items.map((item, index) => ({
    id: index,
    content_type: item.content_type,
    view_urls: {
      full_size: item.content_url,
    },
  }));
</script>

<style style="text/scss" lang="scss">
  .image-container {
    display: flex;
    flex-direction: column;
    gap: 8px;
    cursor: pointer;

    .group-images {
      border-radius: 12px;
      background: #000;
      position: relative;
      overflow: hidden;

      .group-image {
        position: relative;

        img {
          border-radius: 12px;
          object-fit: cover;
          aspect-ratio: 1 / 1;
          width: 350px;
          max-height: 350px;
        }

        .video-container {
          aspect-ratio: 1 / 1;
          width: 350px;
          max-height: 350px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .video-player {
          max-width: 350px;
          height: 100%;
        }
      }
    }
  }

  .image-container.mobile {
    .group-images {
      height: unset !important;
      max-width: unset !important;
      .group-image {
        img, .video-container {
          width: 100%;
        }

        .video-player {
          max-width: 100%;
        }
      }
    }
  }

  * :global(.ui-photos) {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
  }

  * :global(.owl-dots) {
    margin-top: -30px !important;
  }

  * :global(.owl-dot > span) {
    background: white;
    width: 8px;
    height: 8px;
    opacity: 0.7;
  }

  * :global(.ui-photos .owl-next) {
    background: white !important;
    color: black !important;
    z-index: 1;
    padding: 10px;
  }

  * :global(.ui-photos .owl-prev) {
    background: white !important;
    color: black !important;
    z-index: 1;
  }

  * :global(.group-container-hovered .ui-photos .owl-next) {
    opacity: 1 !important;
  }

  * :global(.group-container-hovered .ui-photos .owl-prev) {
    opacity: 1 !important;
  }

  * :global(.ui-single-photo) {
    margin-top: 0px !important;
  }

  * :global(.mobile .owl-stage) {
    display: -webkit-box;
    margin-top: auto;
  }

  * :global(.mobile .owl-item) {
    margin-top: auto;
    margin-bottom: auto;
  }
</style>

<div class="image-container" class:mobile={mobile}>
  <div class="group-images" class:group-container-hovered={hovered}>
    <Photos
      mobile={mobile}
      preventDefaultClick={true}
      useFancyBox={false}
      photos={mediaMap}
      viewContext={'spotlight-carousel'}
      spotlightUser={user}
      alwaysVisible={true}>
      <div class="group-image" slot="img" let:photo>
        {#if (photo.content_type == 'image')}
          <img src={photo.view_urls.full_size} alt='' />
          <div class="image-subtle-overlay"></div>
        {:else}
          <div class="video-container">
            <video class="video-player js-spotlight-video-player" controls controlsList="nodownload" autoplay muted playsinline>
              <source src={photo.view_urls.full_size} />
            </video>
          </div>
        {/if}
      </div>
    </Photos>
  </div>
</div>
